import React from "react";
import HeaderLoggedIn from '../components/HeaderLoggedIn'
import './Content.scss';
import InstagramEmbed from 'react-instagram-embed';

class Content2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <div className="content">
                <HeaderLoggedIn />
                <img src="/content-logo-2.jpg"></img>
                <h1>สายแฟตัวจริงต้องไม่พลาด! อัพเดทเทรนด์แฟชั่นสุดปังปี 2020 สไตล์ไหนอิน ชิ้นไหนเอาท์</h1>
                <div className="contentBody container">
                    <p>
                        1.ลายจุดสุดคิวท์
    กลับมาอีกครั้งกับลาย Polka Dot หรือลายจุดสุดน่ารักที่เคยมาแรงสุด ๆ ในปี 2018 และหวนคืนสู่รันเวย์อีกครั้งในปี 2020 เมื่อหัวเรือใหญ่แห่งวงการแฟชั่นอย่าง Marc Jacobs และ Moschino จับเจ้าลายจุดมาแต่งแต้มเสื้อผ้าให้ดูมีชีวิตชีวามากขึ้น หรือแม้กระทั่ง Alexa Chung นางแบบสาว และแฟชั่นดีไซน์เนอร์คนดังยังเลือกให้เป็นไอเท็ม Top Hit เท่านี้ก็พอจะการันตีได้แล้วว่าถ้าหยิบลายจุดมาใส่ในปี 2020 รับรองเกิดชัวร์
                    </p>

                    <InstagramEmbed
                        url='https://www.instagram.com/p/B3E0QXdh7P-/'
                        maxWidth={320}
                        hideCaption={false}
                        containerTagName='div'
                        protocol=''
                        injectScript
                        onLoading={() => { }}
                        onSuccess={() => { }}
                        onAfterRender={() => { }}
                        onFailure={() => { }}
                    /><p>
                        2.เสื้อคลุมตัวสั้นชิค ๆ
สำหรับสาว ๆ วัยทำงานคนไหนที่มองหาไอเท็มเด็ดมาฟินิชลุคให้ครบสูตร เสื้อคลุมเป็นอีกหนึ่ง
ไอเท็มกันตายที่ควรมีติดตู้เสื้อผ้าไว้ เพราะแค่ทับ ก็ช่วยอัปลุคเรียบ ๆ ให้ดูมีกิมมิคเพิ่มขึ้นได้อีกหลายระดับ แต่สำหรับสาว ๆ คนไหนที่ไม่อยากได้ลุคที่ดูทางการมากจนเกินไป ลองเปลี่ยนมาเสื้อคลุมแบบครอปสั้น ที่จะช่วยเปลี่ยนลุคทางการให้ดูชิคขึ้น พร้อมเฉิดฉายทุกโอกาส

                    </p>

                    <InstagramEmbed
                        url='https://www.instagram.com/p/B5r90JSngeB/'
                        maxWidth={320}
                        hideCaption={false}
                        containerTagName='div'
                        protocol=''
                        injectScript
                        onLoading={() => { }}
                        onSuccess={() => { }}
                        onAfterRender={() => { }}
                        onFailure={() => { }}
                    /><p>
                        3.สีนีออนจี๊ดจ๊าด
อีกหนึ่งเทรนด์ที่เป็นกระแสมาตั้งแต่ช่วงปลายปีนี้ และดูท่าว่าจะยังคงได้รับความนิยมอยู่ในปีหน้า นั่นคือสีนีออนจี๊ดจ๊าดที่สะกดทุกสายตาให้ต้องหันมอง แต่หากสาว ๆ คนไหนที่ยังกลัวการใส่สีนีออน แนะนำให้หาไอเท็มนีออนปังๆ สักชิ้น มาแมตช์กับไอเท็มสีเรียบ เช่น เชิ้ตขาวกับกางเกงสีนีออน หรือ เดรสสีเบจกับแจ็กเกตหนังสีนีออน เพียงเท่านี้ก็จะช่วยให้ปรับลุคให้ดูสนุกมากยิ่งขึ้น

                    </p>

                    <InstagramEmbed
                        url='https://www.instagram.com/p/BoB3V_cHvjA/'
                        maxWidth={320}
                        hideCaption={false}
                        containerTagName='div'
                        protocol=''
                        injectScript
                        onLoading={() => { }}
                        onSuccess={() => { }}
                        onAfterRender={() => { }}
                        onFailure={() => { }}
                    /><p>
                        4.เจิดจรัสด้วยชุดปักเลื่อมและเมทัลลิก
วันไหนเบื่อลุคเรียบๆ ลองหยิบชุดปักเลื่อม หรือชุดหนังเมทัลลิกแววาวมาเพิ่มความหรูหรากันสักหน่อย เพราะปี 2020 ไอเท็มระยิบระยับจะต้องกลับมาทวงบัลลังก์แฟชั่นแน่นอน สังเกตจากการที่
แบรนด์ดังหลายเจ้าอย่าง Saint Laurent หรือ Ralph Lauren ก็เลือกจะปัดฝุ่นชุดปักเลื่อม ทั้งเดรส แจ็กเกต หรือกระโปรงให้กลับมาโลดแล่นบนรันเวย์อีกครั้ง แอบกระซิบว่ายิ่งถ้าใส่ไปออกงานกลางคืน คอนเฟิร์มว่าเกิดแน่นอน ประกายระยิบระยับจากเนื้อผ้าจะช่วยขับผิวให้ดูผ่องขึ้น เจิดจรัสยืนหนึ่งทุกงาน

                    </p>

                    <InstagramEmbed
                        url='https://www.instagram.com/p/B2WEhuKj1TT/'
                        maxWidth={320}
                        hideCaption={false}
                        containerTagName='div'
                        protocol=''
                        injectScript
                        onLoading={() => { }}
                        onSuccess={() => { }}
                        onAfterRender={() => { }}
                        onFailure={() => { }}
                    /><p>
                        5.ลายดอกหวาน ๆ อัพระดับความเฟมินีน
ปิดท้ายด้วยลายดอกที่ไม่ว่าจะผ่านไปกี่ปี ก็ไม่มีเอาท์ มักจะหวนกลับมาให้เราได้รื้อตู้เสื้อผ้า หยิบเอาชุดลายดอกตัวเก่งมาใส่ใหม่เสมอ จุดเด่นสำคัญของลายดอกคือการอัประดับความเฟมินีนแบบสูงสุด แนะทริคว่าลองเลือกเดรสผ้าพริ้ว หรือผ้าชีฟองลายดอก คาดทับด้วยเข็มขัดหนังเก๋ ๆ สักเส้น เพียงเท่านี้ก็คอมพลีตลุคสาวหวานแกมชิคได้แบบครบสูตร

                    </p>

                    <InstagramEmbed
                        url='https://www.instagram.com/p/B0E8GzXJlNP/'
                        maxWidth={320}
                        hideCaption={false}
                        containerTagName='div'
                        protocol=''
                        injectScript
                        onLoading={() => { }}
                        onSuccess={() => { }}
                        onAfterRender={() => { }}
                        onFailure={() => { }}
                    />
                </div>
            </div>
        )
    }
}

export default Content2;